import type { ChildNote } from '../types';

export function compareNotesDescending(first: ChildNote, second: ChildNote): number {
  return new Date(second.datetime).getTime() - new Date(first.datetime).getTime();
}
